import { Component, h } from 'preact';
import cx from 'classnames';

import { LabeledChoice } from '../../../../types/ui/form';
import { inputGridGetStyles, InputGridOptions, inputGridCheckFlex } from '../../../core/input-grid';


interface RadioGroupProps {
  choices: LabeledChoice[];
  value: any;
  showInvalidState?: boolean;

  // Layout options
  layout?: InputGridOptions;
  layoutLg?: InputGridOptions;

  onSelect: (value: any) => void;
}

export class RadioGroup extends Component<RadioGroupProps> {
  render(props: RadioGroupProps) {
    const usingFlex = inputGridCheckFlex(props.layout, props.layoutLg);

    return (
      <div
        className={ cx('hi-radio-group') }
        style={ inputGridGetStyles(props.choices.length, props.layout, props.layoutLg) }>
        { props.choices.map(choice => (
          <label className={ cx({
            'text-danger': props.showInvalidState,
            'mr-2': !usingFlex,
            'mr-4': usingFlex
          }) }>
            <input type="radio"
              checked={ props.value === choice.value }
              onClick={ () => props.onSelect(choice.value) } /> { choice.label }
          </label>
        )) }
      </div>
    );
  }
}
